export default "__VITE_PUBLIC_ASSET__a996f20f__"